import PropTypes from "prop-types";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import {useTranslation} from "react-i18next";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {makeRequest} from "../../services/requestService";
import {API_URL} from "../../constants";

export default function ImportTitleDialog(props) {
    const {t} = useTranslation("common");
    const [filename, setFilename] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [shortname, setShortname] = React.useState("");
    const [name, setName] = React.useState("");
    const [location, setLocation] = React.useState("");

    React.useEffect(() => {
        setFilename("");
        setDescription("");
        setShortname("");
        setName("");
        setLocation("");
    }, [props.open]);

    function handleClose() {
        props.onClose();
    }

    async function handleUpload(event) {
        event.preventDefault();
        const input = document.querySelector("#import-title-dialog-file-input");
        const formData = new FormData();
        formData.set("archive", input.files[0]);
        formData.set("name", name);
        formData.set("description", description);
        formData.set("shortname", shortname);
        formData.set("location", location);

        const url = `${API_URL}/collection/${props.collection}/import`;
        const response = await makeRequest(url, "POST", formData, {
            'Content-Type': 'multipart/form-data'
        });

        if (response.status !== 200) {
            return
        }

        props.onUploaded(response.data.title);
    }

    function handleFilenameUpdate(path) {
        const stripped = path.split("\\");
        setFilename(stripped[stripped.length - 1]);
    }

    return (
        <Dialog open={props.open} onClose={handleClose} onBackdropClick={handleClose} maxWidth="sm"
                fullWidth={true} {...props}>
            <form onSubmit={handleUpload}>
                <DialogTitle sx={{m: 0, p: 2}}>
                    {t("main.pages.collection.actions.import.tooltip")}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent>
                    <Grid container gap={2}>
                        <Grid item xs={12}>
                            <TextField fullWidth value={name}
                                       label={t("main.pages.collection.form.name")}
                                       required
                                       onChange={(event) => setName(event.target.value)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth value={shortname}
                                       label={t("main.pages.collection.form.shortname")}
                                       required
                                       onChange={(event) => setShortname(event.target.value)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth value={description}
                                       label={t("main.pages.collection.form.description")}
                                       required
                                       onChange={(event) => setDescription(event.target.value)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth value={location}
                                       label={t("main.pages.collection.form.location")}
                                       required
                                       onChange={(event) => setLocation(event.target.value)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button component="label" variant="outlined" startIcon={<FileUploadIcon/>}>
                                {t("main.pages.collection.form.upload")}
                                <input id="import-title-dialog-file-input" type="file" accept="application/zip" hidden
                                       onChange={(event) => handleFilenameUpdate(event.target.value)}/>
                            </Button>
                            {filename}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t('main.components.saveDialog.close')}</Button>
                    <Button type="submit">{t('main.components.saveDialog.save')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

ImportTitleDialog.propTypes = {
    collection: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUploaded: PropTypes.func.isRequired
}
